import axios from 'axios';
import qs from 'qs';
import { getCookie, getUrlInfo } from 'utils/helper/helper';
import { handleAPI } from './api';

export const ODINFORGE_URL = process.env.REACT_APP_ENV === 'production' ? process.env.REACT_APP_BI_API : 'https://reports-api.swisspriv.com/api/';

const handleOdinForgeAPI = (path, method, params, data = null, responseType = 'json') => {
  const headers = {
    Accept: 'application/json',
    'Cache-Control': 'no-cache',
  };

  let url = ODINFORGE_URL + path;

  if (params) {
    url = url + '?' + qs.stringify(params, { arrayFormat: 'brackets' });
  }

  return axios({
    method,
    url,
    ...(data && { data }),
    responseType,
    headers,
  });
};

export const getOdinForgeReportsUrl = async () => {
  const token = getCookie('token');

  if (!token) return;

  const crmData = { user: { set_auto_login_token_expiry: true } };

  const autoLoginToken = await handleAPI(`platform/auth/refresh_auto_login_token`, 'PUT', '', crmData);

  const odinForgeData = {
    token: autoLoginToken.data,
    tenant: getUrlInfo().subdomain,
  };

  let odinForgeResponse;

  try {
    odinForgeResponse = await handleOdinForgeAPI('user/autoLogin', 'POST', '', odinForgeData);
  } catch (e) {
    return false;
  }

  return odinForgeResponse?.data;
};
